<template>
  <div>
<!--    <div class="pure_top"></div>-->
    <div class="wrapper cust">
      <video autoplay loop muted playsinline style="width: 100%;">
        <source src="@/assets/images/automotive.mp4" type="video/mp4">
      </video>
<!--      <h1>{{ $t("utils.mall") }}</h1>-->
      <van-tabs v-if="allowStopList.length > 0" v-model="active">
        <van-tab>
          <template #title>
            <div style="display: inline-flex; align-items: center;">
              <van-badge>
                <van-icon name="hot" color="#ee0a24" size="26" class="icon-shake" style="margin-right: 4px;" />
              </van-badge>
              <span>{{ $t('DRIVE AGX Thor') }}</span>
            </div>
          </template>
          <div class="mt-20"></div>
          <div v-for="i in notAllowStopList" class="item" :key="i.id">
            <h3>{{ i[lang] }}</h3>
            <div class="preview" @click="$router.push('/updetail/' + i.id + '/upid/'+ upid)">
              <img :src="i.img" style="width: 150px" />
              <button type="button" class="invest">
                {{ $t('Replace') }}
              </button>
            </div>
            <div class="data">
              <div class="data_rate flex">
                <p>{{ $t("utils.income") }}</p>
                <p>{{ i.rate }}</p>
              </div>
              <div class="data_day flex mt-10">
                <p>{{ $t("Lease Term") }}</p>
                <p>{{ i.day }}{{ $t("utils.day") }}</p>
              </div>
              <div class="data_min flex mt-10">
                <p>{{ $t("Rent Payable") }}</p>
                <p>{{ $t("currency") }}{{ i.min }}</p>
              </div>
            </div>
          </div>
        </van-tab>
        <van-tab :title="$t('DRIVE AGX Orin')">
          <div class="mt-20"></div>
          <div v-for="i in allowStopList" class="item" :key="i.id">
            <h3>{{ i[lang] }}</h3>
            <div class="preview" @click="$router.push('/updetail/' + i.id + '/upid/'+ upid)">
              <img :src="i.img" style="width: 150px" />
              <button type="button" class="invest">
                {{ $t('Replace') }}
              </button>
            </div>
            <div class="data">
              <div class="data_rate flex">
                <p>{{ $t("utils.income") }}</p>
                <p>{{ i.rate }}</p>
              </div>
              <div class="data_day flex mt-10">
                <p>{{ $t("Lease Term") }}</p>
                <p>{{ i.day }}{{ $t("utils.day") }}</p>
              </div>
              <div class="data_min flex mt-10">
                <p>{{ $t("Rent Payable") }}</p>
                <p>{{ $t("currency") }}{{ i.min }}</p>
              </div>
            </div>
          </div>
        </van-tab>
      </van-tabs>
      <div v-else class="mt-20">
        <div v-for="i in data.list" class="item" :key="i.id">
          <h3>{{ i[lang] }}</h3>
          <div class="preview" @click="$router.push('/updetail/' + i.id + '/upid/'+ upid)">
            <img :src="i.img" style="width: 150px" />
            <button type="button" class="invest">
              {{ $t('Replace') }}
            </button>
          </div>
          <div class="data">
            <div class="data_rate flex">
              <p>{{ $t("utils.income") }}</p>
              <p>{{ i.rate }}</p>
            </div>
            <div class="data_day flex mt-10">
              <p>{{ $t("Lease Term") }}</p>
              <p>{{ i.day }}{{ $t("utils.day") }}</p>
            </div>
            <div class="data_min flex mt-10">
              <p>{{ $t("Rent Payable") }}</p>
              <p>{{ $t("currency") }}{{ i.min }}</p>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>
<script>
import Fetch from "../../utils/fetch";
import Vue from "vue";
import { Tab , Progress, Empty, Dialog, Field } from "vant";
Vue.use(Tab).use(Progress).use(Empty).use(Dialog).use(Field);
export default {
  name: "upitem",
  data() {
    return {
      lang: this.$i18n.locale || "en_us",
      id: '',
      upid: '',
      data: [],
      listLength: 0,
      show_tz: false,
      number: "",
      sku: [],
      computed: undefined,
      notAllowStopList: [],
      allowStopList: [],
    };
  },
  created() {
    this.$parent.footer("item");
  },
  mounted() {
    this.id = parseInt(this.$router.history.current.params.id);
    this.upid = parseInt(this.$router.history.current.params.upid);
    this.start();
  },
  methods: {
    start() {
      Fetch("/index/item_glist", {
        id: this.id,
      }).then((r) => {
        this.data = r.data;
        this.listLength = r.data.list.length;

        const list = r.data.list || [];
        // 根据 is_allow_stop 分组
        this.notAllowStopList = list.filter(item => item.is_current === 0);
        this.allowStopList = list.filter(item => item.is_current === 1);
      });
    },
    sort(type) {
      this.start(type);
    },
    buy(item) {
      this.sku = item;
      this.show_tz = true;
    },
    confirm() {
      if (!this.number) {
        this.$toast(this.$t("item.inputAmount"));
        return false;
      }
      Fetch("/index/item_upgrade", {
        id: this.sku.id,
        upid: this.id,
        money: this.number,
      })
      .then((r) => {
        this.$router.push("/order");
      })
      .catch((err) => {
        // this.psd_val = '';
      });
    },
  },
};
</script>

<style lang="less" scoped>
#app{
  position: relative
}
.wrapper {
  position: absolute;
  width: 100%;
  /*top: 5%;*/
  padding-bottom: 70px;
}

h1 {
  font-size: 32px;
  color: #ffffff;
  text-align: center;
  margin-bottom: 15px;
}

.pure_top {
  width: 100%;
  height: 250px;
  position: relative;
  z-index: 0;
  overflow: hidden;
}

.pure_top::after {
  content: "";
  width: 120%;
  height: 100%;
  position: absolute;
  left: -10%;
  top: 0;
  border-radius: 0 0 40% 40%;
  background: #47b897;
}

.item {
  width: 90%;
  margin: 0 auto;
  background-color: #ffffff;
  border-radius: 10px;
  margin-bottom: 15px;
  padding-bottom: 10px;
  box-shadow: 2px 2px 4px #d3d3d3;

  h3 {
    text-align: center;
    font-size: 18px;
    padding: 15px 0;
    border-bottom: 1px solid #cdcdcd;
  }
}

.preview {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 15px 0;
  width: 87%;
  margin: 0 auto;
  border-bottom: 1px solid #cdcdcd;

  .invest {
    background-color: #76b900;
    color: #000;
    border-radius: 5px;
    padding: 10px 15px;
    text-align: center;
    font-size: 14px;
  }
}

.data {
  align-items: center;
  justify-content: space-between;
  padding: 15px 0;
  width: 87%;
  margin: 0 auto;

  >div {
    text-align: left;
    display: flex;
    justify-content: space-between;
    align-items: center;

    >p:first-child {
      color: #82817f;
      font-size: 14px;
    }

    >p:last-child {
      font-size: 16px;
      color: #191f19;
      font-weight: bold;
    }
  }
}

.progress {
  width: 85%;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .van-progress {
    background-color: #686868;
  }

  .tag {
    color: #ffffff;
    background-color: #656565;
    padding: 5px 8px;
    border-radius: 10px;
  }
}

.icon-bounce {
  animation: bounce 1s ease-in-out infinite;
}

@keyframes bounce {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-3px);
  }
}
.icon-blink {
  animation: blink 1.2s ease-in-out infinite;
}

@keyframes blink {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.3;
  }
}
.icon-shake {
  animation: shake 0.4s ease-in-out infinite;
}

@keyframes shake {
  0%, 100% {
    transform: rotate(0deg);
  }
  25% {
    transform: rotate(10deg);
  }
  75% {
    transform: rotate(-10deg);
  }
}

</style>
